import { render, staticRenderFns } from "./WebPrintReceipt.vue?vue&type=template&id=a0f8f54a&"
import script from "./WebPrintReceipt.vue?vue&type=script&lang=js&"
export * from "./WebPrintReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports